import { AppLanguage } from '@skippay/core/i18n/languages';

import csMessages from './translations/cs.json';
import huMessages from './translations/hu.json';
import skMessages from './translations/sk.json';

export function getMessages(language: AppLanguage): Record<string, string> {
	switch (language) {
		case AppLanguage.cs:
			return csMessages.cs;
		case AppLanguage.hu:
			return huMessages.hu;
		case AppLanguage.sk:
			return skMessages.sk;
		default:
			return csMessages.cs;
	}
}
